import React, { useState, useEffect } from 'react';

const AdBlockBanner = () => {
  const [adBlockDetected, setAdBlockDetected] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Metodo 1: Controllo degli script di ads
    const checkAdBlock = async () => {
      let detected = false;

      // Strategia 1: Tentativo di caricare script ads
      try {
        await fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
          method: 'HEAD',
          mode: 'no-cors',
          cache: 'no-store'
        });
      } catch (e) {
        detected = true;
      }

      // Strategia 2: Controllo elementi DOM ads
      if (!detected) {
        const bait = document.createElement('div');
        bait.innerHTML = '&nbsp;';
        bait.className = 'adsbox';
        bait.style.cssText = 'width: 1px; height: 1px; position: absolute; left: -100px; top: -100px; visibility: hidden;';
        document.body.appendChild(bait);
        
        setTimeout(() => {
          if (bait.offsetHeight === 0 || bait.offsetWidth === 0 || 
              window.getComputedStyle(bait).display === 'none') {
            detected = true;
          }
          document.body.removeChild(bait);
        }, 100);
      }

      // Strategia 3: Controllo risorse bloccate
      if (!detected) {
        const baitImage = document.createElement('img');
        baitImage.src = 'https://ad.doubleclick.net/favicon.ico';
        baitImage.onerror = () => {
          detected = true;
          setAdBlockDetected(true);
          setIsVisible(true);
        };
        baitImage.onload = () => {
          setAdBlockDetected(false);
        };
      }

      if (detected) {
        setAdBlockDetected(true);
        setIsVisible(true);
      } else {
        setAdBlockDetected(false);
      }
    };

    checkAdBlock();

    // Controllo periodico (opzionale)
    const interval = setInterval(checkAdBlock, 30000); // Ogni 30 secondi
    
    return () => clearInterval(interval);
  }, []);

  // Se non c'è adblock o l'utente ha chiuso il banner, non mostrare nulla
  if (!adBlockDetected || !isVisible) return null;

  return (
    <div className="adblock-avviso" role="status">
      {/* La ✕ sta nell'ANGOLO del pannello, non in fondo alla riga: in un
          angolo dello schermo il posto della chiusura è l'angolo, e così
          il testo può occupare tutta la larghezza. */}
      <button
        className="adblock-chiudi"
        onClick={() => setIsVisible(false)}
        aria-label="Chiudi avviso"
      >
        ✕
      </button>
      <span className="adblock-icona" aria-hidden="true">⚠️</span>
      <div>
        <p className="adblock-titolo">Rilevato AdBlocker</p>
        <p className="adblock-testo">
          Il tuo AdBlocker potrebbe limitare alcune funzionalità. Per
          supportare <strong>Momoz Shop</strong>, considera di disattivarlo
          per questo sito.
        </p>
      </div>
    </div>
  );
};

export default AdBlockBanner;
